export const columns = [
	{
		id: 'id',
		label: 'Id',
		width: '300px',
		hidden: true,
	},
	{
		id: 'name',
		label: 'Nombre',
	},
	{
		id: 'role',
		label: 'Perfil',
	},
	{
		id: 'status',
		label: 'Estatus',
	},
	{
		id: 'edit',
		label: '',
		removeOrdenation: true,
	},
];
